import React from 'react'
import Carousel from '../Carousel'
import LinkConverter from '../LinkConverter'
import { IProductCarousel } from './types'

// MUI
import ContentModule from '../ContentModule'
import { GatsbyImage } from 'gatsby-plugin-image'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

const ProductCarousel = ({ title, slides, numberOfSlidesInView, readmore }: IProductCarousel) => {
  const { shape } = useTheme()

  const styles = {
    slideItem: {
      listStyle: 'none',
      display: 'block',
      '& .MuiLink-root': {
        color: 'common.black',
        '&:hover': {
          color: 'primary.dark',
        },
      },
    },
    productTitle: {
      typography: 'body2',
      fontWeight: 600,
    },
    slideImage: {
      width: `100%`,
      borderRadius: shape.borderRadius,
      marginBottom: '16px',
    },
  }
  return (
    <Carousel title={title} numberOfSlidesInView={numberOfSlidesInView} readmore={readmore}>
      {slides &&
        slides.map((slide, index: number) => {
          if (!slide) {
            return null // Skip rendering if slide is undefined
          }
          return slide.internal.type === 'ContentfulComponentContentModule' ? (
            <Box component="li" key={index} sx={styles.slideItem}>
              <ContentModule sx={{ image: styles.slideImage }} {...slide} />
            </Box>
          ) : (
            <Box component="li" key={index} sx={styles.slideItem}>
              {/**This is only for backwards compatibility */}
              <LinkConverter linkHref={slide.productLink} linkTitle={slide.title}>
                <GatsbyImage image={slide.productImage.gatsbyImageData} alt={slide.title} style={styles.slideImage} />
                <Typography sx={styles.productTitle}>{slide.title}</Typography>
              </LinkConverter>
            </Box>
          )
        })}
    </Carousel>
  )
}

export default ProductCarousel
